import React, { SetStateAction, useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import {
  EventType,
  WebStoreSelectorType,
} from "../../controller/MasterController";
import { ThemeType } from "../../recoil/theme";
import { CouponSlider } from "./slider/CouponSlider";
import CustomEventSlider from "./slider/CustomEventSlider";
import XmasSlider from "./slider/XmasSlider";
import { langText } from "../../recoil/lang";
import { setRecoil } from "recoil-nexus";
import { visibleCouponListState } from "../../recoil/modal";

interface EventSliderProps {
  storeList: WebStoreSelectorType | undefined;
  lang: number;
  theme: ThemeType;
  adverEventList: EventType[];
}

const EventSlider = ({
  storeList,
  lang,
  theme,
  adverEventList,
}: EventSliderProps) => {
  const [sliderList, setSliderList] = useState<string[]>([]);

  const [count, setCount] = useState<number>(0);
  const [isBack, setIsBack] = useState<boolean>(true);
  const [front, setFront] = useState<string>("");
  const [back, setBack] = useState<string>("");

  const getSlide = (type: string) => {
    switch (type) {
      case "선물상자":
        return <XmasSlider />;
      case "룰렛":
        return (
          <CustomEventSlider
            title={langText.slider_roulette_coupon[lang]}
            type={type}
            color="#FF4588"
            imagePath={`${process.env.PUBLIC_URL}/knockknock/svg/event/ic_slide_event2.svg`}
          />
        );
      case "복주머니":
        return (
          <CustomEventSlider
            title={langText.slider_new_year_coupon[lang]}
            type={type}
            color="#FF3838"
            imagePath={`${process.env.PUBLIC_URL}/knockknock/svg/event/ic_slide_event2.svg`}
          />
        );
      case "틀린그림찾기":
        return (
          <CustomEventSlider
            title="다른 그림 찾고 할인받으세요"
            type={type}
            color="#2bb590"
            imagePath={`${process.env.PUBLIC_URL}/knockknock/svg/event/ic_slide_event2.svg`}
          />
        );
      default:
        return (
          <CouponSlider
            storeList={storeList}
            lang={lang}
            setVisibleCouponListModal={() =>
              setRecoil(visibleCouponListState, true)
            }
          />
        );
    }
  };

  useEffect(() => {
    setSliderList([
      "checkIn",
      ...adverEventList
        .filter((item) => item.used === 0)
        .map((item) => {
          return item.event_name;
        }),
    ]);
  }, [adverEventList]);

  useEffect(() => {
    if (sliderList.length > 0) {
      setFront(sliderList[0]);
      setBack(sliderList[1 % sliderList.length]);
      setIsBack(false);
    }
  }, [sliderList]);

  useEffect(() => {
    setTimeout(() => {
      if (sliderList.length > 1) {
        if (isBack) {
          setFront(sliderList[(count + 1) % sliderList.length]);
          setBack(sliderList[count]);
        } else {
          setFront(sliderList[count]);
          setBack(sliderList[(count + 1) % sliderList.length]);
        }
        setIsBack(!isBack);
        setCount((count + 1) % sliderList.length);
      }
    }, 8000);
  }, [isBack, sliderList]);

  const EventSlider = useMemo(() => {
    return (
      <Style>
        <div className="slideWrap">
          <div className={`flipContainer ${isBack && "active"}`}>
            <div className="back">{getSlide(back)}</div>
            <div className="front">{getSlide(front)}</div>
          </div>
        </div>
      </Style>
    );
  }, [storeList, lang, back, front, isBack]);

  return EventSlider;
};
export default EventSlider;

const Style = styled.div`
  @font-face {
    font-family: "Jalnan2TTF";
    src: url("${process.env.PUBLIC_URL}/knockknock/font/Jalnan2TTF.ttf")
      format("truetype");
    font-weight: 400;
  }

  .slideWrap {
    width: 100%;
    height: 60px;
    padding: 0 20px;
  }

  .flipContainer {
    perspective: 1000px;
    width: 100%;
    height: 100%;
    position: relative;

    .front,
    .back {
      width: 100%;
      height: 100%;
      backface-visibility: hidden;
      position: absolute;
      top: 0;
      left: 0;
      transition: transform 0.5s;
      transform-style: preserve-3d;
    }
    .front {
      z-index: 2;
    }
    .back {
      transform: rotateX(180deg);
      z-index: 1;
    }
  }

  .flipContainer.active {
    .front {
      z-index: 1;
      transform: rotateX(180deg);
    }
    .back {
      z-index: 2;
      transform: rotateX(0deg);
    }
  }
`;
